module.exports = __webpack_public_path__ + "static/biennale-heavy-it-e8638d97369dc86535e29d6c83c44f9e.otf";